const { same } = require('../utils');

exports.computeLockAspectRatioFromCanvasStateItems = canvasStateItems => same(canvasStateItems, 'lockAspectRatio');
